<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=650 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ parentPrinter ? $t('edit_printer') : $t('add_item', { item: $t('printer').toLowerCase() }) }}
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .mb-4.text-md.font-semibold {{ $t('select_printer') }}
      template(v-if="isSearchingPrinters")
        .d-flex.flex-column.justify-center.align-center
          v-progress-circular.ma-auto(:width="3" :size="25" color="info500" indeterminate)
          .mt-3.text-md.neutral500--text {{ $t('searching_printers') }}...
          .mt-1.mb-4.text-xs.info500--text {{ $t('searching_printers_info') }}
      template(v-if="availablePrinters.length > 0")
        v-radio-group(v-model="selectedPrinter" hide-details)
          template(v-for="printer in availablePrinters")
            v-radio.mb-4(:value="printer" color="neutral700" :disabled="printer.added")
              template(v-slot:label)
                .d-flex.flex-column
                  .neutral700--text.text-sm.font-normal {{ printer.name }} ({{ getHostName(printer) }})
                  .danger500--text.text-xs.font-normal(v-if="printer.added") {{ $t('added') }}
      //- div.my-4
      //-   v-form(ref="form")
      //-     v-row(no-gutters)
      //-       v-col.mr-2
      //-         .text-sm.font-semibold.neutral500--text.mb-1 {{ $t('paper_width') }}
      //-         v-text-field.round-xl(v-model.number="paperWidth" outlined type="number" hide-details="auto" :rules="hasPaperSizeUnit ? rules.has_quantity : []" min="0")
      //-       v-col.mr-2
      //-         .text-sm.font-semibold.neutral500--text.mb-1 {{ $t('paper_height') }}
      //-         v-text-field.round-xl(v-model.number="paperHeight" outlined type="number" hide-details="auto" :rules="hasPaperSizeUnit ? rules.has_quantity : []" min="0")
      //-       v-col
      //-         .text-sm.font-semibold.neutral500--text.mb-1 {{ $t('paper_size_unit') }}
      //-         v-select.round-xl(v-model="paperSizeUnit" outlined :items="paperSizeUnitOptions" hide-details="auto" :menu-props="{ bottom: true, offsetY: true }" :rules="paperHeight || paperWidth ? rules.not_empty_select : []" min="0")

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="primary" depressed :disabled="disabledButton" @click="onSave") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean
    },
    parentPrinter: {
      type: Object,
      default: null
    },
    addedPrinters: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    isLoading: false,
    selectedPrinter: null,
    availablePrinters: [],
    isSearchingPrinters: true,
    paperWidth: null,
    paperHeight: null,
    paperSizeUnit: null,
    paperSizeUnitOptions: ['in', 'cm', 'mm'],
    wsInterval: null,
    rules: {
      has_quantity: [v => v != null || 'This field is required', v => v != 0 || 'Must be more than zero'],
      not_empty_select: [v => !!v || 'This field is required']
    },
  }),
  mounted () {
    this.$wamp.subscribe(`iot.list-printers-response:${this.company.slug}`, (args) => {
      if (args) {
        this.availablePrinters = args.map((arg) => {
          return {
            ...arg,
            added: this.checkAdded(arg)
          } 
        })
        this.clearWsInterval()
        if (this.parentPrinter) {
          this.availablePrinters.map(printer => {
            if (printer.device_uri === this.parentPrinter.device_uri) {
              this.selectedPrinter = printer
            }
          })
        }
        this.isSearchingPrinters = false
      }
    })
    this.getAvailablePrinters()
    if (this.parentPrinter) {
      this.paperHeight = this.parentPrinter.paper_height
      this.paperWidth = this.parentPrinter.paper_width
      this.paperSizeUnit = this.parentPrinter.paper_size_unit
    }
  },
  beforeDestroy () {
    this.clearWsInterval()
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disabledButton () {
      return !this.selectedPrinter
    },
    printerPayload () {
      let payload = {
        name: this.selectedPrinter?.name || null,
        device_uri: this.selectedPrinter?.device_uri || null,
        extra_data: this.selectedPrinter?.extra_data
      }
      if (this.hasPaperSize) {
        payload.paper_width = this.paperWidth
        payload.paper_height = this.paperHeight
        payload.paper_size_unit = this.paperSizeUnit
      }
      return payload
    },
    hostParams () {
      return {
        machine_id: this.selectedPrinter?.host?.machine_id || null
      }
    },
    hasPaperSizeUnit () {
      return this.paperSizeUnit !== null
    },
    hasPaperSize () {
      if (this.paperWidth > 0 && this.paperHeight > 0 && this.paperSizeUnit) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    getAvailablePrinters () {
      this.wsInterval = setTimeout(() => {
        this.$wamp.publish(`iot.list-printers:${this.company.slug}`, [])
      }, 2000);
    },
    getHostName (item) {
      return item?.host?.hostname || null
    },
    fetchHost () {
      return this.$axios.get(`iot/${this.company.slug}/hosts`, { params: this.hostParams })
    },
    createHost (payload) {
      return this.$axios.post(`iot/${this.company.slug}/hosts`, payload)
    },
    checkAdded (item) {
      console.log(item);
      if (this.addedPrinters.length === 0) {
        return false
      }
      if (this.parentPrinter && this.parentPrinter?.host?.machine_id === item?.host?.machine_id) {
        return false
      }
      return this.addedPrinters.filter(added => added?.host?.machine_id === item?.host?.machine_id).length > 0
    },
    clearWsInterval () {
      clearInterval(this.wsInterval)
      this.wsInterval = null
    },
    async onSave () {
      // if (!this.$refs.form.validate()) {
      //   return
      // }
      try {
        this.isLoading = true
        const payload = { ...this.printerPayload }
        const { data } = await this.fetchHost()
        if (data.count > 0) {
          payload.host = data.results[0].id
        } else {
          const hostPayload = {
            hostname: this.selectedPrinter.host.hostname,
            machine_id: this.selectedPrinter.host.machine_id
          }
          const hostResp = await this.createHost(this.selectedPrinter.host, hostPayload)
          payload.host = hostResp.data.id
        }
        if (this.parentPrinter) {
          await this.$axios.patch(`/iot/${this.company.slug}/printers/${this.parentPrinter.id}`, payload)
        } else {
          await this.$axios.post(`/iot/${this.company.slug}/printers`, payload)
        }
        this.showMessage(['success', this.$t('success_message.update_successful')])
        this.$emit('updated')
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
